import React from 'react';
import styled from "styled-components";

const SGrammarArticulos = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarArticulos = () => {
  return (
    <SGrammarArticulos>
    <h5>Artículos - Rodzajniki</h5>

<p>Prawie każdy rzeczownik hiszpański jest poprzedzony rodzajnikiem (czasem istnieje możliwość jego pominięcia), co dla Polaka stanowi dosyć duży problem, ponieważ w językach słowiańskich rodzajniki nie występują. Użycie odpowiedniego rodzajnika lub jego brak ma istotne znaczenie dla ogólnego sensu wypowiedzi. Poniżej znajdziecie podstawowe zasady użycia rodzajników w języku hiszpańskim.</p>

<h6>Użycie rodzajników nieokreślonych (<i>un</i>, <i>una</i>, <i>unos</i>, <i>unas</i>)</h6>

<li>przed rzeczownikami określającymi osobę, rzecz lub zjawisko jedno z wielu tego samego rodzaju (<i>Dame <b>un</b> vaso</i> - Daj mi szklankę)</li>
<li>kiedy mówimy o czymś po raz pierwszy (<i>Carmen me presentó a <b>un</b> chico</i> - Carmen przedstawiła mi [pewnego] chłopaka)</li>
<li>jeśli dokonujemy oceny jakiejś osoby, przedmiotu lub zjawiska poprzez użycie przymiotnika (<i>Es <b>una</b> chica muy guapa</i> - To bardzo ładna dziewczyna)</li>
<li>po formie '<i>hay</i>' (<i>En esta calle hay <b>un</b> supermercado</i> - Na tej ulicy jest supermarket)</li>
<li>rodzajnik nieokreślony w liczbie mnogiej często jest tłumaczony na polskie słowo 'kilka'</li>

<h6>Użycie rodzajników określonych (<i>el</i>, <i>la</i>, <i>los</i>, <i>las</i>)</h6>

<li>przed rzeczownikami, które pojawiły się już wcześniej w wypowiedzi (<i>Al lado de mi casa hay una tienda. En <b>la</b> tienda puedes comprar de todo</i> - Obok mojego domu jest sklep. W sklepie możesz kupić wszystko)</li>
<li>kiedy wszyscy rozmówcy znają omawianą osobę lub przedmiot (<i><b>El</b> hombre que conociste en la fiesta es mi primo</i> - Mężczyzna, którego poznałeś na imprezie, to mój kuzyn)</li>
<li>gdy rzeczownik określa cały typ lub grupę (<i><b>La</b> mujer suele ganar menos que <b>el</b> hombre</i> - Kobieta zazwyczaj zarabia mniej niż mężczyzna)</li>
<li>gdy rzeczownik określa konkretny przedmiot lub osobę (<i>Llamaron a <b>la</b> puerta</i> - Zadzwonili do drzwi)</li>
<li>Przed rzeczownikami abstrakcyjnymi bez przymiotnika (<i><b>La</b> vida es dura</i> - Życie jest ciężkie)</li>
<li>przed rzeczownikami określającymi pojedyncze rzeczy (<i><b>El</b> sol salió a las seis</i> - Słońce wzeszło o szóstej)</li>
<li>przed nazwami nauk, języków, religii</li>
<li>przy podawaniu godzin, dni tygodnia, etc.</li>
<li>przed tytułami grzecznościowymi i naukowymi</li>
<li>przed rzeczownikami określającymi części ciała</li>
<li>z nazwami rzek, gór, etc.</li>

<h6>Najważniejsze przypadki opuszczania rodzajnika</h6>

<li>kiedy nie jest istotny przedmiot, o którym mówimy, tylko sam fakt (<i>Ya tengo piso</i> - Już mam mieszkanie)</li>
<li>w liczbie mnogiej, kiedy mówimy o typie przedmiotów (<i>Aqui venden libros</i> - Tu sprzedaje się książki)</li>
<li>po '<i>no tener</i>' i '<i>no hay</i>'</li>
<li>przed rzeczownikami niepoliczalnymi</li>
<li>przed nazwami krajów, miast, etc.</li>
<li>przed imionami i nazwiskami</li>
<li>jeśli rzeczownik jest poprzedzony zaimkiem</li>
    </SGrammarArticulos>
  );
};

export default GrammarArticulos;